/**
 * @generated SignedSource<<c94a94ec5ed1dc8c88270cf7420c4a62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ArchiveReportTemplateInput = {
  templateId: string;
};
export type useReportTemplateArchiveMutation$variables = {
  input: ArchiveReportTemplateInput;
};
export type useReportTemplateArchiveMutation$data = {
  readonly archiveReportTemplate: {
    readonly reportTemplate: {
      readonly id: string;
      readonly organization: {
        readonly id: string;
      } | null;
    };
  } | null;
};
export type useReportTemplateArchiveMutation = {
  variables: useReportTemplateArchiveMutation$variables;
  response: useReportTemplateArchiveMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ArchiveReportTemplatePayload",
    "kind": "LinkedField",
    "name": "archiveReportTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReportTemplate",
        "kind": "LinkedField",
        "name": "reportTemplate",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useReportTemplateArchiveMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useReportTemplateArchiveMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "16488b724e746e80a3c87357f8d02cd4",
    "id": null,
    "metadata": {},
    "name": "useReportTemplateArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation useReportTemplateArchiveMutation(\n  $input: ArchiveReportTemplateInput!\n) {\n  archiveReportTemplate(input: $input) {\n    reportTemplate {\n      id\n      organization {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3e51a603c07dba0f105e6d2dc1a3d380";

export default node;
